import React from "react";
import { Input } from "@mui/material";
import { Colors } from "../theme/colors";

const CssTextField = (props: any) => {
  return (
    <Input
      {...props}
      inputProps={{
        style: { padding: 5 },
      }}
      sx={{
        color: Colors.Maximum_blue_purple,
        border: `1px solid ${Colors.lavender_blue}`,
        borderRadius: "10px",

        "&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active":
        {
          WebkitBoxShadow: `0 0 0 1000px ${Colors.white} inset !important`,
          WebkitTextFillColor: `${Colors.Maximum_blue_purple} !important`,
          caretColor: Colors.Maximum_blue_purple,
        },

        "&:focus-within": {
          backgroundColor: Colors.white,
          borderColor: Colors.slate_blue,
          color: Colors.slate_blue,
        },
      }}
    />
  );
};

export default CssTextField;
